import React from 'react'
import { Button, ButtonProps } from 'antd'
import { useTranslation } from 'react-i18next'
import { trackButtonClick } from '../../../utils/gtmUtils'

interface GooglePlayButtonProps extends Omit<ButtonProps, 'onClick'> {
    url?: string
    iconClassName?: string
    location?: string
}

const GooglePlayButton: React.FC<GooglePlayButtonProps> = ({
    url = 'https://play.google.com/store/apps/details?id=com.dailyvents.prod',
    type = 'default',
    size = 'large',
    className,
    iconClassName,
    location = 'unknown',
    ...rest
}) => {
    const { t } = useTranslation()

    const handleClick = () => {
        trackButtonClick('google_play', location, {
            url,
        })
        window.open(url, '_blank')
    }

    return (
        <Button
            type={type}
            size={size}
            className={className}
            onClick={handleClick}
            {...rest}
        >
            <span className={iconClassName}>
                <img
                    src="/img/Playstore_logo.svg"
                    alt={t('common.alt.googleStore')}
                />
            </span>
            Google Play
        </Button>
    )
}

export default GooglePlayButton
